import { createNanoEvents } from "nanoevents";

type Events = {
  onUserUnauthenticated: () => void;
  formWillRefresh: (params: {
    resource: string;
    id: string | undefined;
    type: "edit" | "create";
    tab?: string;
  }) => void;
};

export const emitter = createNanoEvents<Events>();

export function emitUserUnauthenticated() {
  emitter.emit("onUserUnauthenticated");
}

export function listenUserUnauthenticated(cb: () => void) {
  return emitter.on("onUserUnauthenticated", cb);
}
